import { render, staticRenderFns } from "./AccidentStatistic.vue?vue&type=template&id=5b9b4c8a&"
import script from "./AccidentStatistic.vue?vue&type=script&lang=js&"
export * from "./AccidentStatistic.vue?vue&type=script&lang=js&"
import style0 from "./AccidentStatistic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b9b4c8a')) {
      api.createRecord('5b9b4c8a', component.options)
    } else {
      api.reload('5b9b4c8a', component.options)
    }
    module.hot.accept("./AccidentStatistic.vue?vue&type=template&id=5b9b4c8a&", function () {
      api.rerender('5b9b4c8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/biz/AccidentStatistic.vue"
export default component.exports